import ApiService, { ApiArguments } from '@/api/api_service';
import {
  ZoomPhoneWidgetEventApi,
  ZoomPhoneWidgetEventApiCreateZoomPhoneWidgetEventRequest,
} from '@/api/openapi';

export class ZoomPhoneWidgetEventApiService extends ApiService {
  api = new ZoomPhoneWidgetEventApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async createZoomPhoneWidgetEvent(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneWidgetEventApiCreateZoomPhoneWidgetEventRequest>,
  ) {
    return this.checkResponse<void>(this.api.createZoomPhoneWidgetEvent(request, options), errorHandlers);
  }
}
